import React from 'react';
import { getColor } from 'random-material-color';
import { makeStyles } from '@material-ui/styles';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  item: {
    display: 'flex',
  },
  avatarContainer: {
    width: 51,
  },
  avatar: {
    height: 36,
    width: 36,
  },
  nameContainer: {
    flexGrow: 1,
  },
  userName: {
    margin: 0,
    padding: 0,
    lineHeight: '16px',
  },
  avaName: {
    margin: 0,
    padding: 0,
    color: 'grey',
    fontSize: 14,
    lineHeight: '16px',
  },
});

const JoinConversationOption = ({ innerRef, data: { user }, isFocused, isSelected, innerProps }) => {
  const classes = useStyles();

  return (
    <MenuItem
      buttonRef={innerRef}
      selected={isFocused}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
      {...innerProps}
    >
      <div className={classes.item}>
        <div className={classes.avatarContainer}>
          {user.userName && (
            <Avatar
              key="avatar"
              className={classes.avatar}
              src={user.userPhoto?.url}
              alt={user.userName}
              style={{ backgroundColor: getColor({ text: user.avaName }) }}
            >
              {user.userName[0]}
            </Avatar>
          )}
        </div>
        <div className={classes.nameContainer}>
          <Typography className={classes.userName} variant="subtitle1">
            {user.userName}
          </Typography>
          <Typography className={classes.avaName} variant="body1">
            &{user.avaName}
          </Typography>
        </div>
      </div>
    </MenuItem>
  );
};

export default JoinConversationOption;
